import React, { useCallback } from 'react';

import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import { Box, Typography } from '@mui/material';
import { LocaleToLanguageMap, LocaleType } from '@provider-portal/common/utils/translations';

interface MenuLanguageProps {
  locale: LocaleType;
  isActive: boolean;
  onSelect: (language: LocaleType) => void;
}

const MenuLanguage: React.FC<MenuLanguageProps> = ({ isActive, locale, onSelect }) => {
  const onClick = useCallback(() => onSelect(locale), [locale, onSelect]);

  return (
    <Box display="flex" alignItems="center" onClick={onClick} mb={1}>
      <Box mr={1}>
        {isActive ? (
          <RadioButtonCheckedIcon color="primary" />
        ) : (
          <RadioButtonUncheckedIcon color="secondary" />
        )}
      </Box>
      <Box>
        <Typography variant="bodyM" color={isActive ? 'primary' : 'default'}>
          {LocaleToLanguageMap[locale]}
        </Typography>
      </Box>
    </Box>
  );
};

export default MenuLanguage;
